import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { useLanguage } from '../context/LanguageContext';
const NAV_ITEMS = [{
  key: 'home',
  to: '/'
}, {
  key: 'services',
  to: '/services'
}, {
  key: 'about',
  to: '/about'
}, {
  key: 'contact',
  to: '/contact'
}] as const;
export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const isActive = (to: string) => to !== '#' && pathname === to;
  const LangToggle = () => <div className="flex items-center bg-gray-50 border border-gray-200 rounded-md p-0.5" data-id="element-55">
      <button type="button" onClick={() => setLang('en')} aria-pressed={lang === 'en'} className={lang === 'en' ? 'px-3 py-1.5 bg-navy text-white text-xs font-bold rounded shadow-sm' : 'px-3 py-1.5 text-gray-500 hover:text-navy text-xs font-bold rounded transition-colors'} data-id="element-56">
        EN
      </button>
      <button type="button" onClick={() => setLang('es')} aria-pressed={lang === 'es'} className={lang === 'es' ? 'px-3 py-1.5 bg-navy text-white text-xs font-bold rounded shadow-sm' : 'px-3 py-1.5 text-gray-500 hover:text-navy text-xs font-bold rounded transition-colors'} data-id="element-57">
        ES
      </button>
    </div>;
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm" data-id="element-58">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-59">
        {/* Logo Area */}
        <Link to="/" className="flex items-center gap-3.5" aria-label="MDA Production & Process Solutions home" data-id="element-60">
          <Logo variant="light" data-id="element-61" />
          <span className="flex flex-col leading-none text-left" data-id="element-62">
            <span className="text-[#1f5180] font-poppins font-bold text-xl sm:text-2xl tracking-tight" data-id="element-63">
              MDA
            </span>
            <span className="text-[#1f5180]/80 font-medium text-[10px] sm:text-xs tracking-wide mt-1" data-id="element-64">
              Production &amp; Process Solutions
            </span>
          </span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-65">
          {NAV_ITEMS.map(link => <Link key={link.key} to={link.to} className={isActive(link.to) ? 'text-navy font-semibold text-sm hover:text-brandOrange transition-colors' : 'text-gray-600 font-medium text-sm hover:text-navy transition-colors'} data-id="element-66">
              {t.nav[link.key]}
            </Link>)}
        </nav>

        {/* Right Actions */}
        <div className="hidden md:flex items-center gap-4" data-id="element-67">
          <LangToggle data-id="element-68" />
          <Link to="/contact" className="bg-brandOrange hover:bg-brandOrange-hover text-white px-5 py-2.5 rounded font-semibold transition-colors text-sm shadow-sm" data-id="element-69">
            {t.nav.requestConsulting}
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-navy p-2" aria-label={menuOpen ? 'Close menu' : 'Open menu'} aria-expanded={menuOpen} onClick={() => setMenuOpen(v => !v)} data-id="element-70">
          {menuOpen ? <X className="w-6 h-6" data-id="element-71" /> : <Menu className="w-6 h-6" data-id="element-72" />}
        </button>
      </div>

      {/* Mobile Menu Panel */}
      {menuOpen && <div className="md:hidden border-t border-gray-100 bg-white px-6 py-6" data-id="element-73">
          <nav className="flex flex-col gap-1 mb-6" data-id="element-74">
            {NAV_ITEMS.map(link => <Link key={link.key} to={link.to} onClick={() => setMenuOpen(false)} className={isActive(link.to) ? 'text-navy font-semibold text-base py-2' : 'text-gray-600 font-medium text-base py-2 hover:text-navy transition-colors'} data-id="element-75">
                {t.nav[link.key]}
              </Link>)}
          </nav>
          <div className="flex items-center gap-4" data-id="element-76">
            <LangToggle data-id="element-77" />
            <Link to="/contact" onClick={() => setMenuOpen(false)} className="flex-1 text-center bg-brandOrange hover:bg-brandOrange-hover text-white px-5 py-2.5 rounded font-semibold transition-colors text-sm shadow-sm" data-id="element-78">
              {t.nav.requestConsulting}
            </Link>
          </div>
        </div>}
    </header>;
}